import React, {useState} from 'react';
import { withStyles } from "@mui/styles";
import {Dialog, DialogContent, DialogTitle, IconButton, Typography} from '@mui/material';
import {connect} from "trim-redux";
import {useTranslation} from "react-i18next";
import {Close} from "@mui/icons-material";
import {Styles} from "../../../../config/design/styles";
import Button from "@mui/material/Button";
import {ChevronRight, MessageCircle, Star} from "lucide-react";
import Grid from "@mui/material/Grid2";
import LoadingButton from "../../../components/elements/LoadingButton";
import axios from "axios";
import {defaultVariables} from "../../../../config";
import RayaField from "../../../components/elements/fields/RayaField";
import {Rating} from "@mui/lab";
import Tooltip from "@mui/material/Tooltip";

function MakeCommentButton({order,role,classes,reload }) {
    const { t } = useTranslation();
    const [open,setOpen] = useState(false);
    const [comment,setComment] = useState("");
    const [rate,setRate] = useState(5);
    const [submitLoading, setSubmitLoading] = useState(false);

    const handleRequest = async () => {
        setSubmitLoading(true);
        const data = new FormData();
        data.append('order_id', order.id);
        data.append('rate', rate);
        data.append('comment', comment);

        const loginToken = localStorage.getItem('ACT');
        const config = {
            headers: {
                Accept: 'application/json',
                Authorization: `Bearer ${loginToken}`
            }
        };

        try {
            const response = await axios.post(`${defaultVariables.url}/comments/create`, data, config);
            setSubmitLoading(false);
            reload(response.data);
            setOpen(false);
        } catch (error) {
            console.error(error.response);
            setSubmitLoading(false);

        }
    }
    return (
        <>

            <div className="comment-btn-holder flex-space">
                {
                    !!order.comment ?
                        <div className="flex-direction">
                            <Tooltip title={t('yourCommentSubmited')} className="flex-direction" placement="right" style={{gap:2}}>
                                <div className="flex-direction" style={{gap:0}}>
                                    <Star className="rating-icon" />
                                    {order.comment.rate}
                                </div>

                            </Tooltip>

                        </div>
                        :
                        <>
                            <Button
                                onClick={() => setOpen(true)}
                                startIcon={<MessageCircle/>}
                                color="secondary"
                                variant="contained"
                            >
                                {t('addComment')}
                            </Button>
                        </>
                }

            </div>
            <Dialog  open={open} onClose={() => setOpen(false)} fullWidth maxWidth="sm" className="overflow-x-hidden">
                <DialogTitle className="dialog-title">
                    {t('addComment')}
                    <IconButton
                        onClick={() => setOpen(false)}
                        style={{position:"absolute",right:15,top:15}}
                        size="small"
                    >
                        <Close className="lucide-icon"/>
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2} style={{padding:10}}>
                        <Grid item size={12}>
                            <Typography align="center">{t('commentDesc')}</Typography>
                        </Grid>
                        <Grid item size={12} style={{textAlign:"center"}}>
                            <Rating
                                precision={1}
                                value={rate}
                                size="large"
                                onChange={(event, newValue) => {
                                    setRate(newValue);
                                }}
                            />
                        </Grid>
                        <Grid item size={12}>
                            <RayaField
                                variant="outlined"
                                multiline
                                fullWidth
                                name="comment"
                                label={t('comment')}
                                type="text"
                                rows="4"
                                value={comment}
                                onChange={(e) => setComment(e.target.value)}
                            />
                        </Grid>

                        <Grid item size={12}>
                            <LoadingButton
                                className="confirm-btn"
                                variant="contained"
                                color="secondary"
                                onClick={() => handleRequest()}
                                loading={submitLoading}
                            >
                                {t("submitComment")}
                            </LoadingButton>
                        </Grid>
                    </Grid>
                </DialogContent>
            </Dialog>
        </>

    );
}
const mapStateToProps = (state) => ({
    isAuth: state.isAuth,
});

export default withStyles(Styles)(connect(mapStateToProps)(MakeCommentButton));
